import axios from "axios";

import setting from "../services/setting";

const defaultConfig = {
  baseURL: `${setting.http.base_url}`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

const instance = axios.create(defaultConfig);

instance.interceptors.request.use(
  async (config) => {
    const token = window.localStorage.getItem("token")

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.data?.message != null) {
      let message = Array.isArray(error.response.data.message) ? error.response.data.message.join("\r\n") : typeof error.response.data.message == "string" ? error.response.data.message : "";
      return Promise.reject(message);
    }
    // Do here anything, for example: logout, o redirect
    return Promise.reject(error);
  }
);

export const request = instance;
